// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sgqjthvzbegkdeszoxue.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNncWp0aHZ6YmVna2Rlc3pveHVlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0MjI1MTAsImV4cCI6MjA3Mjk5ODUxMH0.ubUwbbjLKwpYbYCnkW7xh89qYwR4U-5RtE1y6To242g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});